import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';

interface IUpdateOfTheLauncherCheckBox {
	toggleUpdateOfTheLauncher: () => void;
	updateOfTheLauncher: boolean;
}

const UpdateOfTheLauncherCheckBox: React.FC<IUpdateOfTheLauncherCheckBox> = ({
	toggleUpdateOfTheLauncher,
	updateOfTheLauncher,
}) => {
	return (
		<Form.Item name="updateOfTheLauncher">
			<Checkbox checked={updateOfTheLauncher} onChange={toggleUpdateOfTheLauncher}>
				<Text
					translationNameSpace="form"
					translationKey="automaticUpdateOfLauncherVersionLabel"
					asFragment={true}
				/>
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(UpdateOfTheLauncherCheckBox);
